import React, { Component } from 'react'
import { useEffect } from "react";
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { updateComponent, fetchData,sendOTP } from '../../state/actions/componentsActions'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'
import Textbox from '../textbox'
import { camelize, getValidationsResult, cleanupString } from '../../utils'
import MobileDetect from 'mobile-detect'
const RECAPTCHA_SITEKEY=process.env.RECAPTCHA_SITEKEY
class MobileWithOTPButton extends Component {
    constructor(props) {
        super(props)
        this.state = {
            value: props.component.value || ''
        }
        window.handleRecaptcha = this.handleRecaptcha.bind(this)
        this.sendOTP = this.sendOTP.bind(this)
    }
    handleChange(e) {
        const val = e.target.value
        this.setState({ value: val });
        const { dispatch, component } = this.props
        const delta = {}
        if (e.target.type === 'text') {
            delta.value = cleanupString(e.target.value)
            if (!!component.hint) {
                delta.hint = { ...component.hint, visible: false }
            }
        }
        if (Object.keys(delta).length >0) {
            component.value = delta.value
            dispatch(updateComponent(component.id, delta))
        }
        dispatch(
            updateComponent('CELLULARE-CODICE_CELLULARE', {
              value:''
            }, { avoidValidation: true })
          )
    }
    onBlur(e) {
        const { dispatch, component } = this.props
        const delta = {}
        if (e.target.type === 'text') {
            delta.value = cleanupString(e.target.value)
            if (!!component.hint) {
                delta.hint = { ...component.hint, visible: false }
            }
        }
        if (Object.keys(delta).length > 0) {
            component.value = delta.value
            dispatch(updateComponent(component.id, delta))
        }
    }
    sendOTP(){
        const { dispatch, component,components } = this.props
        let body = {}
        if (component.fetch.hasOwnProperty('fields')) {
            component.fetch.fields.forEach(field =>
              Object.keys(field).forEach(
                key => (body[field[key].fieldName] = components[key].value)
              )
            )
          }
          dispatch(sendOTP(component.fetch.url,body))
    }
    handleRecaptcha(){
        const { dispatch, component,components } = this.props
        let body = {}
        if (component.fetch.hasOwnProperty('fields')) {
            component.fetch.fields.forEach(field =>
              Object.keys(field).forEach(
                key => (body[field[key].fieldName] = components[key].value)
              )
            )
          }
          dispatch(sendOTP(component.fetch.url,body))
	}
    onSubmit(){
        grecaptcha.execute()
    }
    AddLibrary(urlOfTheLibrary) {
        const script = document.createElement("script")
        script.src = urlOfTheLibrary
        script.async = true
        script.defer=true
        document.body.appendChild(script)
      }
    getProperErrorMessage() {
        const { component } = this.props

        if (!!component.validations.overrides) {
            const validationResult = getValidationsResult({
                component,
                type: 'overrides'
            })
            if (!validationResult.result) {
                return validationResult.errorMessage
            }
        }
        return component.errorMessage && component.errorMessage[0]
    }
    render() {
        
        const { widget, component } = this.props
        const md = new MobileDetect(window.navigator.userAgent)
        const isResumePage = window.location.pathname.indexOf('/resume') >= 0 ? true : false
        return (
            <div {...css(this.props.styles.component,!md.mobile() && !isResumePage && this.props.styles.divmain,
                isResumePage&& this.props.styles.divResume)}>
                <div>
                <div {...css(!md.mobile() && !isResumePage && this.props.styles.divMobileNum)}>
                        <input type='text' 
                        {...css(
                            this.props.styles.input,
                            component.status.indexOf('error') > -1 &&
                            this.props.styles['input--invalid'],
                            component.status.indexOf('loading') > -1 &&
                            this.props.styles['input--blink'])
                        }
                            onChange={this.handleChange.bind(this)}
                            onBlur={this.onBlur.bind(this)}
                            name={component.id}
                            placeholder={component.cleanName}  value={component.value}/>
                        <span
                            {...css(
                                this.props.styles.label,
                                this.state.value !== '' && this.props.styles['label--active']
                            )}
                        >
                            {component.cleanName}
                        </span>
                        <span {...css(component.otpbtnDisabled ? this.props.styles.otpMsgvisible : this.props.styles.otpMsghidden,
                            isResumePage && this.props.styles.otpMsgvisible)}>
                        Cliccando su ‘Invia il codice di verifica’ riceverai un SMS con il codice OTP</span>
                        <small {...css(this.props.styles['error-msg'])}>
                            {camelize(this.getProperErrorMessage(), true, true)}
                        </small>
                        {!!component.hint && !!component.hint.visible ? (
                            <span {...css(this.props.styles.hint)}>
                                {this.props.component.hint.value}
                            </span>
                        ) : (
                                ''
                            )}
                    </div>
                    <div {...css(!md.mobile() && this.props.styles.divOTPAlign,
                        isResumePage && this.props.styles.otpMsgvisible)}>
                        <button onClick={this.onSubmit.bind(this)} disabled={component.otpbtnDisabled} {...css(this.props.styles.button,md.mobile() && this.props.styles.mobile_otpButtonAlign, this.props.styles.otpButtonColor,!component.otpbtnDisabled && this.props.styles.buttonOTPEnabled)}>Invia il codice di verifica</button>
                    </div>
                    <div>
                    {this.AddLibrary("https://www.google.com/recaptcha/api.js")}
                        <div class="g-recaptcha"
                         data-sitekey={RECAPTCHA_SITEKEY}
                         data-callback="handleRecaptcha"
                         data-size="invisible">
                         </div>
                    </div>
                </div>
                {/* <div {...css(component.otpbtnDisabled?this.props.styles.otpMsgvisible:this.props.styles.otpMsghidden)}>Cliccando su ‘Invia il codice di verifica’ riceverai un SMS con il codice OTP</div> */}
            </div>
        )

    }
}
MobileWithOTPButton.propTypes = {
    widget: PropTypes.object.isRequired,
    component: PropTypes.object.isRequired,
    type: PropTypes.oneOf(['text']),
    styles: PropTypes.object.isRequired
}
const mapStateToProps = (state, ownProps) => {
    const { components } = state
    return { components }
    //return {}
}

export default connect(mapStateToProps)(withStyles(Styles)(MobileWithOTPButton))


// WEBPACK FOOTER //
// ./components/mobileWithOTPButton/index.js